import React, { useState } from 'react';
import { Pencil, FileText } from 'lucide-react';
import ToggleSwitch from './ToggleSwitch';

const PolicyItem = ({ policy }) => {
  const [isEnabled, setIsEnabled] = useState(Math.random() > 0.5);
  
  return (
    <div className="p-4 rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-700/30">
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <h3 className="font-medium text-gray-900 dark:text-white">{policy.name}</h3>
          <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
            {policy.description}
          </p>
        </div>
        
        <div className="flex items-center space-x-3 ml-4">
          <ToggleSwitch enabled={isEnabled} onChange={setIsEnabled} />
          <button className="p-2 text-gray-500 hover:text-indigo-600 dark:hover:text-indigo-400 rounded-full hover:bg-indigo-50 dark:hover:bg-indigo-900/30">
          <Pencil className="h-5 w-5" />
          </button>
        </div>
      </div>
      
      {isEnabled && policy.name.includes("Policy") && (
        <div className="mt-3 pt-3 border-t border-gray-200 dark:border-gray-700">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Duration
              </label>
              <select className="w-full rounded-lg border border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100 p-2 text-sm">
                <option>30 days</option>
                <option>60 days</option>
                <option>90 days</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Approval Required
              </label>
              <select className="w-full rounded-lg border border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100 p-2 text-sm">
                <option>Yes</option>
                <option>No</option>
              </select>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PolicyItem;
